import { useAdmin } from "../AdminContext";

export function DashboardPage() {
  const { admin } = useAdmin();

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>Admin Dashboard</h1>
      </header>

      <div className="admin-dashboard">
        <div className="dashboard-welcome">
          <h2>Welcome, {admin?.email}</h2>
          <p>Role: {admin?.role === "super_admin" ? "Super Admin" : "Support"}</p>
        </div>

        <div className="dashboard-stats">
          <div className="stat-card">
            <h3>Organizations</h3>
            <p className="stat-value">-</p>
            <a href="/admin/organizations">Manage Organizations</a>
          </div>

          <div className="stat-card">
            <h3>Users</h3>
            <p className="stat-value">-</p>
            <a href="/admin/users">Manage Users</a>
          </div>

          <div className="stat-card">
            <h3>Recent Activity</h3>
            <p className="stat-value">-</p>
            <a href="/admin/audit">View Audit Logs</a>
          </div>
        </div>

        <div className="dashboard-quick-actions">
          <h3>Quick Actions</h3>
          <div className="quick-actions-grid">
            <a href="/admin/organizations/new" className="quick-action-btn">
              Create Organization
            </a>
            <a href="/admin/users" className="quick-action-btn">
              Search Users
            </a>
            <a href="/admin/audit" className="quick-action-btn">
              View Recent Activity
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
